import { useQuery } from '@tanstack/react-query';
import { scanApi } from '@/services/api';

export function useStats() {
  return useQuery({
    queryKey: ['stats'],
    queryFn: () => scanApi.getStatistics(),
    staleTime: 5 * 60_000,
  });
}
